import { createReducer, on } from '@ngrx/store';
import * as TemplatesActions from './templates.actions';
import { Template, TemplateState } from '../../models/template.model';

export const initialState: TemplateState = {
  templates: [],
  selectedTemplate: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  },
};

export const templatesReducer = createReducer(
  initialState,

  // Load Templates
  on(TemplatesActions.loadTemplates, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TemplatesActions.loadTemplatesSuccess, (state, { templates, pagination }) => ({
    ...state,
    templates,
    pagination,
    loading: false,
  })),
  on(TemplatesActions.loadTemplatesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Load Template
  on(TemplatesActions.loadTemplate, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TemplatesActions.loadTemplateSuccess, (state, { template }) => ({
    ...state,
    selectedTemplate: template,
    loading: false,
  })),
  on(TemplatesActions.loadTemplateFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Create Template
  on(TemplatesActions.createTemplate, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TemplatesActions.createTemplateSuccess, (state, { template }) => ({
    ...state,
    templates: [...state.templates, template],
    loading: false,
  })),
  on(TemplatesActions.createTemplateFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Update Template
  on(TemplatesActions.updateTemplate, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TemplatesActions.updateTemplateSuccess, (state, { template }) => ({
    ...state,
    templates: state.templates.map((t) => (t.id === template.id ? template : t)),
    selectedTemplate: template,
    loading: false,
  })),
  on(TemplatesActions.updateTemplateFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Delete Template
  on(TemplatesActions.deleteTemplate, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TemplatesActions.deleteTemplateSuccess, (state, { id }) => ({
    ...state,
    templates: state.templates.filter((t) => t.id !== id),
    loading: false,
  })),
  on(TemplatesActions.deleteTemplateFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
